/**************************************************************************************************/
/*   File: /src/app/shared/enums/export.type.enum.ts                                              */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Wednesday May 29th 2019                                                        */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The export type enum
 */
export enum ExportType {
    LIGHT = 1,
    FULL = 2
}